import validate from "/home/forge/app.eis-s.de/releases/20241106093900/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import current_45module_45global from "/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/currentModule.global.js";
import is_45authenticated_45global from "/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/isAuthenticated.global.js";
export const globalMiddleware = [
  validate,
  current_45module_45global,
  is_45authenticated_45global
]
export const namedMiddleware = {
  auth: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/auth.ts"),
  "can-access-route": () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/canAccessRoute.js"),
  guest: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/guest.ts"),
  unverified: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/unverified.ts"),
  verified: () => import("/home/forge/app.eis-s.de/releases/20241106093900/client/middleware/verified.ts")
}